import React, {FC, useRef} from 'react';

import {SandboxScenariosEnum, StepSlug} from '../../../../helpers/sandbox/sandboxScenarioHelpers';
import {ChatIntroEducationTipCoordinator} from '../educationTips/chatIntroEducationTipCoordinator';
import {ChatShowcaseKnowledgeBaseEducationTipCoordinator} from '../educationTips/chatShowcaseKnowledgeBaseEducationTipCoordinator';
import {useSandboxStepIncrement} from '../educationTips/sandboxEducationTipCoordinator';
import {SandboxChatPreview} from './sandboxChatPreview';

/*
 * Props.
 */

interface SandboxChatPreviewCoordinatorProps {
  conversationId: number | undefined;
}

/*
 * Constants.
 */

const scenario = SandboxScenariosEnum.SCENARIO3_ACT4;
const steps: ReadonlyArray<string> = Object.freeze([
  'start-scenario-3-conversation-4',
  'showcase-knowledge-base',
]) satisfies ReadonlyArray<StepSlug<SandboxScenariosEnum.SCENARIO3_ACT4>>;

/*
 * Component.
 */

export const SandboxChatPreviewCoordinator: FC<SandboxChatPreviewCoordinatorProps> = (props) => {
  const {conversationId} = props;
  const [, conversationSandbox] = useSandboxStepIncrement(conversationId);

  // Show a preview of the chat widget when we're on the relevant steps.
  const isVisible =
    conversationSandbox?.scenario === scenario &&
    steps.includes(conversationSandbox?.step) &&
    !conversationSandbox?.completed;

  const windowRef = useRef<HTMLDivElement>(null);
  const articleRef = useRef<HTMLDivElement>(null);

  if (!isVisible) {
    return null;
  }

  return (
    <>
      <SandboxChatPreview windowRef={windowRef} articleRef={articleRef} step={conversationSandbox?.step} />
      <ChatIntroEducationTipCoordinator anchor={windowRef} conversationId={conversationId} />
      <ChatShowcaseKnowledgeBaseEducationTipCoordinator anchor={articleRef} conversationId={conversationId} />
    </>
  );
};
